<template>
    <svg
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60">
        <path
            d="M42.0889 47.9999H20.4119C19.2885 47.9999 18.9284 46.4872 19.9313 45.981L26.9588 42.4337C27.1079 42.3585 27.2725 42.3193 27.4395 42.3193H42.0889C42.6781 42.3193 43.1556 42.7968 43.1556 43.386V46.9332C43.1556 47.5223 42.6781 47.9999 42.0889 47.9999Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M40.5812 42.4267V39.9445C40.5812 37.0061 39.4056 34.1899 37.3165 32.1237L20.9669 15.9528"
            stroke="#EEEEEE" />
        <path
            d="M19.9215 46.0107L42.8969 46.0107"
            stroke="#EEEEEE" />
        <circle
            cx="2.1709"
            cy="2.1709"
            r="2.6709"
            transform="matrix(-1 0 0 1 21.186 11.9999)"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
    </svg>
</template>

<script setup lang="ts"></script>
